import {
    AlertTypes,
    GenericFormContainer,
    IAlertData,
    Leap4Breadcrumbs,
    Mode,
    MuiIcons
} from "@leap4/frontend";
import {useHistory} from "react-router-dom";
import {connect, ConnectedProps} from "react-redux";
import {urlService} from "../../../routing/urlsService";
import {setAlert} from "../../../../actions/alert";
import {DetailsForm} from "../DetailsForm";

const {Toc: CreateIcon} = MuiIcons;

export interface IEditGroupProps extends PropsFromRedux {
    setGroup: (data: IAlertData) => void;
}

const mapStateToProps = () => ({});

const mapActions = {
    setAlert
}

const connector = connect(mapStateToProps, mapActions);
type PropsFromRedux = ConnectedProps<typeof connector>;


const _addOwnership = (props: IEditGroupProps) => {
    const setAlert = props.setAlert
    const history = useHistory();

    const onSubmit = async () => {
        setAlert("Ownership created successfully", AlertTypes.SUCCESS)
        history.push(urlService.organizations());
    };

    return (
        <>
            <Leap4Breadcrumbs breadcrumbs={[{
                text: "ownership ",
                link: urlService.organizations(),
                icon: <CreateIcon/>
                },
                {
                    text: "create new",
                    link: urlService.organizations(),
                    icon: <CreateIcon/>
                },
            ]}
            />
            <GenericFormContainer mode={Mode.Create} onCreateOrEditFunc={onSubmit} buttonsProps={{editCreate: {"disabled":true}}}>
                <DetailsForm />
            </GenericFormContainer>
        </>
    )
}

export const addOwnership = connect(mapStateToProps, {
    setAlert
})(_addOwnership);
